import gql from 'graphql-tag';

const GET_RECORD_BY_ORDER_ID = gql`
    query recordByItemId($itemId: String!) {
        recordByItemId(itemId: $itemId) {
            status,
            message,
            data {
                id,
                url,
                duration,
                status,
                pickerId,
                destinationNumber,
                os,
                creationTime
            }
        }
    }
`;

export default GET_RECORD_BY_ORDER_ID;
